import { IEnvironment } from "../app/models/environment.model";

export const environment: IEnvironment = {
  production: true,
  ...window.visuallConfig
};
